<template>
  <div class="appNav">
    <nav>
      <el-scrollbar :native="false" :noresize="true" style="width: 100%">
        <div class="navBar">
          <el-menu
              :default-active="$route.path"
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              router
              :collapse="sidebarCollapsed"
          >
            <template v-for="item in newNavLinks">
              <template v-if="item.children">
                <el-submenu
                    v-show="permissionCode.has(item.permissionCode)"
                    :key="item.path"
                    :index="item.path"
                    :class="{
                    'is-active': $route.meta.active === item.routerName,
                  }">
                  <template slot="title">
                    <SvgIcon
                        v-if="activeSubmenu(item.routerName)"
                        :icon-class="item.active_icon"
                    />
                    <SvgIcon v-else :icon-class="item.icon"/>
                    <span
                        :class="{
                        'title-active': activeSubmenu(item.routerName),
                      }"
                    >{{ item.name }}</span
                    >
                  </template>
                  <el-menu-item-group
                      v-for="itemChildren in item.children"
                      :key="itemChildren.name"
                  >
                    <el-menu-item
                        v-show="permissionCode.has(itemChildren.permissionCode)"
                        :index="itemChildren.path"
                        :class="{
                        'is-active':
                          $route.meta.active === itemChildren.routerName,
                      }"
                    >
                      <span>{{ itemChildren.name }}</span>
                    </el-menu-item>
                  </el-menu-item-group>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item
                    v-show="permissionCode.has(item.permissionCode)"
                    :key="item.path"
                    :index="item.path"
                    :class="[
                    { 'is-active': $route.meta.active === item.routerName },
                    { 'is-settings': item.routerName === 'Settings' },
                  ]"
                >
                  <SvgIcon
                      v-if="activeSubmenu(item.routerName)"
                      :icon-class="item.active_icon"
                  />
                  <SvgIcon v-else :icon-class="item.icon"/>
                  <span slot="title">{{ item.name }}</span></el-menu-item
                >
              </template>
            </template>
          </el-menu>
        </div>
      </el-scrollbar>
    </nav>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {navLinks} from "@/mixins/navLinks";

export default {
  name: "AppNav",
  data() {
    return {
      newNavLinks: [],
      loginInfo: {},
    };
  },
  created() {
    this.loginInfo = JSON.parse(localStorage.getItem("loginData"));
  },
  computed: {
    ...mapState("app", ["sidebarCollapsed"]),
    ...mapState("user", ["permissionCode"]),
  },
  async mounted() {
    this.newNavLinks = JSON.parse(JSON.stringify(navLinks));
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleOpen(key, keyPath) {
      // console.log(key, keyPath)
      // console.log(111);
    },
    // eslint-disable-next-line no-unused-vars
    handleClose(key, keyPath) {
      // console.log(222);
      // console.log(key, keyPath)
    },
    activeSubmenu(name) {
      if (name === "AdministrativeCenter") {
        if (
            this.$route.meta.active === "StationManagement" ||
            this.$route.meta.active === "UnitManagement" ||
            this.$route.meta.active === "PersonnelManagement"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (name === "TeachingCenter") {
        if (
            this.$route.meta.active === "ClassifyManagement" ||
            this.$route.meta.active === "TagManagement" ||
            this.$route.meta.active === "SeriesManagement" ||
            this.$route.meta.active === "ApprovalManagement" ||
            this.$route.meta.active === "ProductionManagement"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (name === "CourseCenter") {
        if (
            this.$route.meta.active === "MaterialCenter" ||
            this.$route.meta.active === "CourseManagement" ||
            this.$route.meta.active === "QuestionManagement"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (name === "PluginManagement") {
        if (
            this.$route.meta.active === "DailyClock" ||
            this.$route.meta.active === "QuestionBank"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (name === "FuZhuManagement") {
        if (
            this.$route.meta.active === "BuManagement" ||
            this.$route.meta.active === "RoleManagement"
        ) {
          return true;
        } else {
          return false;
        }
      }
      if (name === "TransactionCenter") {
        if (this.$route.meta.active === "OrderManagement") {
          return true;
        } else {
          return false;
        }
      }
      if (name === "DataCenter") {
        if (
            this.$route.meta.active === "StudentData" ||
            this.$route.meta.active === "TeachingData"
        ) {
          return true;
        } else {
          return false;
        }
      }
      // else {
      if (name !== this.$route.meta.active) {
        return false;
      } else {
        return true;
      }
      // }
    },
    handleSetting() {
      this.active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: $sideBarWidth;
  min-height: 500px;
}

.appNav {
  position: relative;

  nav {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
    transition: all 250ms ease-in-out;
    //background: #00284D;
    ::v-deep .el-scrollbar__thumb {
      display: none;
    }

    ::v-deep .el-scrollbar__wrap {
      //overflow-x: hidden;
      overflow-y: hidden;
    }

    ::v-deep .is-horizontal {
      display: none;
    }

    .navBar {
      //margin-top: 40px;
      $navBarActiveBgColor: map-get($colors, primary);
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      ::v-deep .el-menu-item-group__title {
        display: none;
      }

      .title-active {
        color: $navBarActiveBgColor;
      }

      .el-menu-item {
        height: 40px;
        line-height: 40px;
        width: 100%;
        text-align: left;
      }

      ::v-deep .el-menu-item {
        color: #000000;
        font-size: 14px;
        font-weight: bold;
      }

      .el-menu-item:hover {
        background: rgba(#ffffff, 15%);
        color: $navBarActiveBgColor;
      }

      ::v-deep .el-menu {
        border-right: none;
        //padding-left: 10px;
      }

      .el-submenu {
        text-align: left;
        border-right: none;

        ::v-deep .el-submenu__title {
          height: 40px;
          line-height: 40px;
          color: #000000;
          font-size: 14px;
          font-weight: bold;
        }

        ::v-deep .el-submenu__title:hover {
          background: rgba(#ffffff, 15%);
          color: $navBarActiveBgColor;
        }

        ::v-deep .el-menu-item {
          padding-left: 3em;
        }

        ::v-deep .el-menu-item {
          color: #666666;
          font-size: 12px;
        }
      }

      ::v-deep .el-menu-item.is-active {
        //color: #67e199;
        color: $navBarActiveBgColor;
        background: rgba(#ffffff, 15%);
      }

      ::v-deep .el-menu-item.is-settings {
        width: $sideBarWidth - 20px;
        position: fixed;
        bottom: 20px;
      }

      .svg-icon {
        font-size: 14px;
        margin-right: 1em;
      }
    }

    .user-info {
      font-size: 12px;
      line-height: 2;
      letter-spacing: 1px;
    }

    .logout {
      margin-top: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .button {
        color: white;
        width: 60%;
      }
    }
  }
}
</style>
